import React from "react";

export const Title: React.FC = () => {
  return (
    <div className="columns is-vcentered">
      <div className="column has-text-left">
        <h1 className="title">場所マスタ</h1>
      </div>
    </div>
  );
};

export default Title;
